module.exports = __webpack_public_path__ + "img/98.55512c49.png";